var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const imageType = "wix-draft-plugin-image";
const imageTypeLegacy = "IMAGE";
const galleryType = "wix-draft-plugin-gallery";
const collapsibleListType = "wix-rich-content-plugin-collapsible-list";
const tableType = "wix-rich-content-plugin-table";
function imageEntityToGallery(data, index) {
  const src = data.src;
  const url = src.file_name;
  const metadata = data.metadata;
  return {
    metadata: {
      height: src.height,
      width: src.width,
      title: metadata && metadata.caption || "",
      altText: metadata && metadata.alt || ""
    },
    url,
    disableDownload: data.disableDownload
  };
}
const blockToImagesKeys = {
  [imageType]: (entity, blockKey) => {
    var _a;
    if (!((_a = entity.data) == null ? void 0 : _a.disableExpand))
      return { [blockKey]: 1 };
  },
  [imageTypeLegacy]: (entity, blockKey) => {
    var _a;
    if (!((_a = entity.data) == null ? void 0 : _a.disableExpand))
      return { [blockKey]: 1 };
  },
  [tableType]: (entity) => {
    let tableImagesKeys = {};
    getTableCellContents(entity).forEach((content) => {
      const blockKeys = contentTraverser(content);
      const imageKeys = blockKeys.length ? Object.assign(...blockKeys) : {};
      tableImagesKeys = __spreadValues(__spreadValues({}, tableImagesKeys), imageKeys);
    });
    return tableImagesKeys;
  },
  [collapsibleListType]: (entity) => {
    var _a;
    let collapsibleListType2 = {};
    (_a = entity.data) == null ? void 0 : _a.pairs.forEach((pair) => {
      const blockKeys = contentTraverser(pair.content);
      const imageKeys = blockKeys.length ? Object.assign(...blockKeys) : {};
      collapsibleListType2 = __spreadValues(__spreadValues({}, collapsibleListType2), imageKeys);
    });
    return collapsibleListType2;
  },
  [galleryType]: (entity, blockKey) => {
    var _a;
    if (!((_a = entity.data) == null ? void 0 : _a.disableExpand))
      return { [blockKey]: entity.data.items.length };
  }
};
function contentTraverser({ blocks, entityMap }) {
  return blocks.map((block) => {
    var _a, _b;
    const entityKey = (_a = block.entityRanges[0]) == null ? void 0 : _a.key;
    const blockKey = block.key;
    const entity = entityMap[entityKey];
    const entityType = entity == null ? void 0 : entity.type;
    return (_b = blockToImagesKeys[entityType]) == null ? void 0 : _b.call(blockToImagesKeys, entity, blockKey);
  }).filter((x) => x);
}
function innerRceImagesMapper(entityMap, index) {
  const images = [];
  Object.entries(entityMap).forEach(([, block]) => {
    var _a, _b;
    if (block.type === imageType || block.type === imageTypeLegacy) {
      ((_a = block.data) == null ? void 0 : _a.src) && !((_b = block.data) == null ? void 0 : _b.disableExpand) && images.push(imageEntityToGallery(block.data));
    }
  });
  return images;
}
function getTableCellContents(tableEntity) {
  const contents = [];
  const { rows } = tableEntity.data.config;
  Object.entries(rows).forEach(([, row]) => {
    var _a;
    Object.entries((_a = row.columns) != null ? _a : {}).forEach(([, cell]) => {
      contents.push(cell.content);
    });
  });
  return contents;
}
function getTableImages(entity, index) {
  return getTableCellContents(entity).map((content) => innerRceImagesMapper(content.entityMap)).flat();
}
function getCollapsibleListImages(entity, index) {
  let collapsibleListType2 = [];
  entity.data.pairs.forEach((pair) => {
    collapsibleListType2 = [
      ...collapsibleListType2,
      ...innerRceImagesMapper(pair.content.entityMap)
    ];
  });
  return collapsibleListType2;
}
function convertEntityToGalleryItems(entity, index) {
  var _a, _b;
  switch (entity.type) {
    case imageType:
    case imageTypeLegacy:
      return entity.data.src && !((_a = entity.data) == null ? void 0 : _a.disableExpand) ? [imageEntityToGallery(entity.data)] : [];
    case galleryType: {
      return ((_b = entity.data) == null ? void 0 : _b.disableExpand) ? [] : entity.data.items.map((item) => {
        return __spreadProps(__spreadValues({}, item), { disableDownload: entity.data.disableDownload });
      });
    }
    case tableType: {
      return getTableImages(entity);
    }
    case collapsibleListType: {
      return getCollapsibleListImages(entity);
    }
    default:
      return [];
  }
}
function createImageMap(content) {
  const blockKeys = contentTraverser(content);
  let imageIndex = 0;
  return blockKeys.reduce((imageMap, blockKeyAndImagesCountObjects) => {
    Object.entries(blockKeyAndImagesCountObjects).forEach(([key, size]) => {
      imageMap[key] = imageIndex;
      imageIndex += size;
    });
    return imageMap;
  }, {});
}
function getImages(entityMap) {
  return Object.values(entityMap).map(convertEntityToGalleryItems).reduce((imagesData, imageData) => {
    return imagesData.concat(imageData);
  }, []);
}
function getImagesData(content) {
  const images = getImages(content.entityMap);
  return { images, imageMap: createImageMap(content) };
}

export { getImagesData as default };
